export const CALLBACK_REMINDER_SPACE_VARIABLE = '--hop-callback-reminder-space'

export const CALLBACK_REMINDER_STACK_BOTTOM = '1rem'

export const callbackReminderSpace = (stackHeight: number) =>
  `calc(${stackHeight}px + ${CALLBACK_REMINDER_STACK_BOTTOM})`

export const aboveCallbackReminders = (padding: string) =>
  `calc(${padding} + var(${CALLBACK_REMINDER_SPACE_VARIABLE}, 0px))`
